import(/* webpackMode: "eager" */ "E:\\Projects\\central-line-build\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "E:\\Projects\\central-line-build\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "E:\\Projects\\central-line-build\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\Projects\\central-line-build\\src\\components\\ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JWTProvider"] */ "E:\\Projects\\central-line-build\\src\\components\\JWTProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProvider"] */ "E:\\Projects\\central-line-build\\src\\components\\Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "E:\\Projects\\central-line-build\\src\\components\\UserProvider.tsx");
